import { render, staticRenderFns } from "./CompactColorPicker.vue?vue&type=template&id=388b277e&scoped=true"
import script from "./CompactColorPicker.vue?vue&type=script&lang=js"
export * from "./CompactColorPicker.vue?vue&type=script&lang=js"
import style0 from "./CompactColorPicker.vue?vue&type=style&index=0&id=388b277e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388b277e",
  null
  
)

export default component.exports